import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './HomeFacilities.scss';
import Slider from 'react-slick';
import Images from '../../Assets/Images/Images';
import ImageModal from '../ImageModal/ImageModal';

const HomeFacilities = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState('');

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const handleImageModalOpen = (imageUrl) => {
    setShowModal(true);
    setSelectedImageUrl(imageUrl)
  };

  const renderSlides = () => {
    return Images.homeCarousel.map((slide) => {
      const {
        image,
        text
      } = slide;
      return (
        <div
          className='home-facilities__carousel--slide'
          onClick={() => handleImageModalOpen(image)}
        >
          <div
            className='home-facilities__carousel--image'
            style={{ backgroundImage: `url("${image}")` }}
          />
          <p className='home-facilities__carousel--title'>{text}</p>
        </div>
      )
    })
  };

  return (
    <div className='home-facilities'>
      <Container>
        <Row>
          <Col>
            <h2 className='home-facilities__title'>Building and Room Facilities</h2>
          </Col>
        </Row>
        <Row>
          <Col md={6} lg={{ span: 3, offset: 3 }}>
            <ul className='home-facilities__list'>
              <li>Air Conditioning</li>
              <li>Fully Furnished</li>
              <li>24Hr Security & CCTV</li>
              <li>Intercom</li>
              <li>Room Cleaning</li>
              <li>Laundry</li>
            </ul>
          </Col>
          <Col md={6} lg={3}>
            <ul className='home-facilities__list'>
              <li>Wi-Fi</li>
              <li>Kitchen</li>
              <li>Guest Area</li>
              <li>Parking Area</li>
              <li>Common Area</li>
              <li>Dispenser</li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col>
            <Slider
              className='home-facilities__carousel'
              {...settings}
            >
              {renderSlides()}
            </Slider>
          </Col>
        </Row>
      </Container>
      <ImageModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        imageUrl={selectedImageUrl}
      />
    </div>
  );
};

export default HomeFacilities;
